import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const DetailsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px;
  background-color: ${colors.white};
  border-top: 1px solid ${colors.gray300};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    padding: 12px;
  }
`

export const ContractCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0;
`

export const DetailCard = styled.div<{ $isClickable?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  background-color: ${colors.white};
  border: none;
  min-width: 200px;
  flex-shrink: 0;
  position: relative;
  ${({ $isClickable }) =>
    $isClickable &&
    `
    cursor: pointer;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: ${colors.gray50};
    }
  `};

  @media (max-width: 1200px) {
    min-width: 180px;
    padding: 12px;
    gap: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
  }
`

export const CardIcon = styled.div<{ bgColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: ${({ bgColor }) => bgColor};
  flex-shrink: 0;

  @media (max-width: 1200px) {
    width: 36px;
    height: 36px;
  }
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`

export const CardTitle = styled.div`
  font-size: 0.875rem;
  line-height: 1.4;
  color: ${colors.gray600};
  font-weight: 500;

  @media (max-width: 1200px) {
    font-size: 0.8rem;
  }
`

export const CardAmount = styled.div`
  font-size: 1.25rem;
  font-weight: 500;
  color: ${colors.gray900};

  @media (max-width: 1200px) {
    font-size: 1.1rem;
  }
`

export const CardBreakdown = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
`

export const BreakdownItem = styled.div`
  font-size: 0.8rem;
  color: ${colors.gray600};

  @media (max-width: 1200px) {
    font-size: 0.75rem;
  }
`

export const ContractInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 4px;
`

export const ContractNumber = styled.div`
  font-size: 0.875rem;
  color: ${colors.gray700};
  font-weight: 500;
`

export const ContractDate = styled.div`
  font-size: 0.875rem;
  color: ${colors.gray600};
`

export const CardChevron = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;

  @media (max-width: 768px) {
    top: 12px;
    right: 12px;
  }
`

export const SummaryRow = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1.5fr 1.5fr 1.5fr;
  gap: 24px;
  padding: 20px;
  border: 1px solid ${colors.gray300};
  border-radius: 8px;
  align-items: start;
  width: 100%;

  @media (max-width: 1400px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 16px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }

  @media (max-width: 768px) {
    padding: 12px;
    gap: 12px;
  }
`

export const ContractIconContainer = styled.div<{ bgColor?: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ bgColor }) => bgColor || colors.gray300};
  padding: 7px;
  border-radius: 8.75px;
  flex-shrink: 0;

  svg {
    display: block;
  }
`

export const ContractTableRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ContractTableRow = styled.div<{ $isClickable?: boolean }>`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr 1.5fr 1.5fr;
  gap: 24px;
  padding: 20px;
  align-items: start;
  font-size: 14px;
  font-weight: normal;
  background-color: rgba(236, 236, 240, 0.3);
  ${({ $isClickable }) =>
    $isClickable &&
    `
    cursor: pointer;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: rgba(236, 236, 240, 0.5);
    }
  `};

  @media (max-width: 1400px) {
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    gap: 16px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }

  @media (max-width: 768px) {
    padding: 12px;
    gap: 12px;
  }
`

export const TotalSummaryRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  padding: 20px;
  align-items: start;
  font-size: 14px;
  font-weight: normal;
  background-color: rgba(236, 236, 240, 0.3);
  width: 100%;

  @media (max-width: 1400px) {
    gap: 16px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }

  @media (max-width: 768px) {
    padding: 12px;
    gap: 12px;
  }
`
